import picture from "@/assets/range.jpg?w=640;960;1280&format=avif;webp;jpg&quality=70&as=picture";
import type { MarketingPicture } from "@/lib/marketing-images";

export const rangePic = picture as MarketingPicture;
